import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    text: {
        inputNo: 'Please enter the device number.',
        search: 'Query',
        whereNo: 'Where is the device number?',
        whereNoStep1: '1. Find the device nameplate',
        whereNoStep2: '2. Check the number',
        nameplate: 'Device nameplate',
        noNote: 'Note: Enter only the numbers in the number (letters and hyphens "-" are not required)',
        currentNo: 'Query number: ',
        switchNo: 'Switch number',
        switchDevice: 'Switch device',
        model: 'Model: ',
        manufactureDate: 'Manufacture date: ',
        deviceDetails: 'Device details',
        sparePartsList: 'Spare parts',
        supportingEquipment: 'Supporting equipment',
        aboutUs: 'About us',
        productIntroduction: 'Introduction',
        productTraceability: 'Traceability',
        reportRepair: 'Repair',
        resetNo: 'Re-enter device number',
        resetNoTip: 'Close current device info and re-enter number',
        clear: 'Clear',
        downloadList: 'Download list',
        selectPparePartsTip: 'Please select spare parts',
        loading: 'Loading...',
        reason: 'Reason',
        selectPlaceholder: 'Select',
        detailReasonPlaceholder: 'Please provide detailed description.',
        contactPerson: 'Reporter',
        contactTel: 'E-Mail',
        repairReasonInputTip: 'Please enter reason or description.',
        contactPersonInputTip: 'Please enter Reporter.',
        contactTelInputTip: 'Please enter E-Mail.',
        submit: 'Submit',
        repairHistory: 'Record',
        confirm: 'Confirm',
        cancel: 'Cancel',
        equipmentDamaged: 'Equipment damaged',
        replaceSpareParts: 'Replace spare parts',
        debug: 'Debug',
        other: 'Other',
        desc: 'Description',
        repairPerson: 'Reporter',
        productionInfo: 'Production',
        blockchainInfo: 'Blockchain',
        workshop: 'Workshop',
        workstation: 'Workstation',
        qualityInfo: 'Quality inspection',
        factoryInfo: 'Factory',
        loadingPoint: 'Loading point',
        driver: 'Driver',
        blockHeight: 'Block height',
        enter: 'Enter',
        uploading: 'Uploading...',
        uploadFail: 'Upload failed.',
        close: 'Close',
        copySuccess: 'Copied to clipboard',
        copyFail: 'Copy failed',
        afterSales: 'After-sales service',
        moreProducts: 'More products',
        contactUs: 'Contact us',
        contactUsTip: 'Contact us for a quote.',
        labelTel: 'TEL:',
        labelEmail: 'E-Mail:',
        labelWebsite: 'Website:',
        antiFakeLabel: 'Anti-counterfeiting',
        welcomeTip: 'Welcome to the Pre-sales & After-sales Consulting Service Channel of<br>Shanxi Haiyang Hydraulic Co., Ltd.'
    },
    image: {
      guide_1_1: 'hy/guide1-1-en.jpg',
      guide_1_2: 'hy/guide1-2-en.jpg',
      guide_1_3: 'hy/guide1-3-en.jpg',
      guide_2_1: 'hy/device_bp_en.png',
    }
  },
  zh: {
    text: {
      inputNo: '请输入设备编号',
      search: '查询',
      whereNo: '设备编号在哪里？',
      whereNoStep1: '1. 找到设备标牌',
      whereNoStep2: '2. 查看编号',
      nameplate: '设备标牌',
      noNote: '注：输入编号中的所有数字 (字母和横线“-”无需输入)',
      currentNo: '本次查询编号：',
      switchNo: '切换编号',
      switchDevice: '切换设备',
      model: '型号：',
      manufactureDate: '出厂：',
      deviceDetails: '设备详情',
      sparePartsList: '备件清单',
      supportingEquipment: '配套设备',
      aboutUs: '关于我们',
      productIntroduction: '产品介绍',
      productTraceability: '产品溯源',
      reportRepair: '报修',
      resetNo: '重置设备编号',
      resetNoTip: '关闭当前设备信息，并重新输入编号',
      clear: '清空',
      downloadList: '下载清单',
      selectPparePartsTip: '请选择备件',
      loading: '加载中...',
      reason: '原因',
      selectPlaceholder: '请选择',
      detailReasonPlaceholder: '请填写详细说明',
      contactPerson: '联系人',
      contactTel: '联系方式',
      repairReasonInputTip: '请填写报修原因',
      contactPersonInputTip: '请填写联系人',
      contactTelInputTip: '请填写联系方式',
      submit: '提交',
      repairHistory: '报修记录',
      confirm: '确认',
      cancel: '取消',
      equipmentDamaged: '设备损坏',
      replaceSpareParts: '更换备件',
      debug: '调试',
      other: '其它',
      desc: '说明',
      repairPerson: '报修人',
      productionInfo: '生产信息',
      blockchainInfo: '区块链信息',
      workshop: '车间',
      workstation: '工位',
      qualityInfo: '质检信息',
      factoryInfo: '出厂信息',
      loadingPoint: '装车点',
      driver: '司机',
      blockHeight: '区块高度',
      enter: '请输入',
      uploading: '上传中...',
      uploadFail: '上传失败',
      close: '关闭',
      copySuccess: '复制成功',
      copyFail: '复制失败',
      afterSales: '售后服务',
      moreProducts: '更多产品',
      contactUs: '联系我们',
      contactUsTip: '联系我们获取报价',
      labelTel: '电话：',
      labelEmail: '邮箱：',
      labelWebsite: '网站：',
      antiFakeLabel: '防伪验证电话',
      welcomeTip: '欢迎进入山西海洋液压有限公司<br>售后及售前咨询服务频道'
    },
    image: {
      guide_1_1: 'hy/guide1-1.jpg',
      guide_1_2: 'hy/guide1-2.jpg',
      guide_1_3: 'hy/guide1-3.jpg',
      guide_2_1: 'hy/device_bp.png',
    }
  }
}

export const SUPPORTED_LOCALES = ['zh', 'en'];
export const LOCALE_STORAGE_KEY = 'app_locale';

// 把 'zh'、'zh-CN'、'zh-Hant'、'en-US' 等统一成 'zh' / 'en'，不支持的返回 ''
function normalizeLocale(locale) {
  if (!locale) return '';
  const languageCode = String(locale).toLowerCase().split('-')[0]; // 取前两位，例如：zh、en
  return SUPPORTED_LOCALES.indexOf(languageCode) > -1 ? languageCode : '';
}

function getBrowserLanguage() {
  const language = navigator.language || navigator.userLanguage; // 获取浏览器语言
  return normalizeLocale(language) || 'en'; // 默认英文
}

function getStoredLocale() {
  try {
    return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch (e) {
    return '';
  }
}

// 默认语言：用户上次选择 > 浏览器语言 > 英文
export function getDefaultLocale() {
  return getStoredLocale() || getBrowserLanguage();
}

// 切换语言，并记住用户的选择
export function setLocale(locale) {
  const next = normalizeLocale(locale);
  if (!next || next === i18n.locale) return;
  i18n.locale = next;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, next);
  } catch (e) {
    // 隐私模式等场景下写入失败，忽略即可
  }
}

// 在中英之间切换，返回切换后的语言
export function toggleLocale() {
  setLocale(i18n.locale === 'zh' ? 'en' : 'zh');
  return i18n.locale;
}

const i18n = new VueI18n({
  locale: getDefaultLocale(), //zh en 设置默认语言
  messages, // 语言包
})

export default i18n
